import { wrapRunner } from './util.js';
/**
 * Parallel runner, that runs all functions given in parallel
 */
export class ParallelRunner {
    async run(fn) {
        return await fn();
    }
    wrap(fn) {
        return wrapRunner(fn, this);
    }
    static instance = new ParallelRunner();
}
/**
 * Instance of {@link ParallelRunner}, since there is no real reason to make multiple instances
 */
export const parallelRunner = ParallelRunner.instance;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFyYWxsZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcGFyYWxsZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLFdBQVcsQ0FBQTtBQUV0Qzs7R0FFRztBQUNILE1BQU0sT0FBTyxjQUFjO0lBQzFCLEtBQUssQ0FBQyxHQUFHLENBQUksRUFBb0I7UUFDaEMsT0FBTyxNQUFNLEVBQUUsRUFBRSxDQUFBO0lBQ2xCLENBQUM7SUFFRCxJQUFJLENBQ0gsRUFBOEI7UUFFOUIsT0FBTyxVQUFVLENBQUMsRUFBRSxFQUFFLElBQUksQ0FBQyxDQUFBO0lBQzVCLENBQUM7SUFFRCxNQUFNLENBQUMsUUFBUSxHQUFHLElBQUksY0FBYyxFQUFFLENBQUE7O0FBR3ZDOztHQUVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sY0FBYyxHQUFHLGNBQWMsQ0FBQyxRQUFRLENBQUEifQ==